module.exports = __webpack_public_path__ + "img/pencil.9780ca4b.svg";